import { GetterTree } from 'vuex'
import { State } from '@/store/index'
import Connection from '@/api/models/Connection'
import { Status } from '@/api/models/Status'
import Account from '@/api/models/Account'
import { ProductProperty } from '@/models/ProductProperty';

export const getters: GetterTree<State, State> = {
    isLoading: (state: State): boolean => {
        return state.loading
    },
    currentConnection: (state: State): Connection => {
        return state.connection
    },
    currentAccount: (state: State): Account|undefined => {
        return state.accounts.find((account: Account) => account.id === state.currentAccountId)
    },
    currentAccounts: (state: State): Array<Account> => {
        return state.accounts
    },
    getSystemStatusesList (state: State): Array<Status> {
        return state.systemStatuses
    },
    getCdekStatusesList (state: State): Array<Status> {
        return state.cdekStatuses
    },
    getSystemProductStatusesList (state: State): Array<Status> {
        return state.systemProductStatuses
    },
    getSystemPaymentStatusesList (state: State): Array<Status> {
        return state.systemPaymentStatuses
    },
    getProductProperties (state: State): Array<ProductProperty> {
        return state.productProperties
    }
}
